import { getEnvironmentPublic } from '@web-app/helpers';
import Head from 'next/head';

import { getStaticPathImage } from '@core/media';
import { ELanguageTags, EMetalSlug, ERouting, ViewCMSProps } from '@core/type';
import { SanityCharts, SanityPageResponse } from '@core/type/sanity';

import { makeServerProps } from '../../../../helpers/make-server-props/make-server-props';
import { useCMSPage } from '../../../../hooks/use-cms-page';
import { ViewCharts } from '../../../../view';

export type PageRouteChart = {
  metalSlug: EMetalSlug;
  slug: string[];
  language: ELanguageTags;
};

export type ViewChartProps = ViewCMSProps<SanityPageResponse>;

const PageCharts = (props: ViewChartProps) => {
  const { host } = getEnvironmentPublic();
  return (
    <>
      <Head>
        <link
          rel="preload"
          as="image"
          href={getStaticPathImage('charts/title-pattern.png', host)}
        />
      </Head>
      {useCMSPage<SanityCharts>({
        ...props,
        ViewPage: ViewCharts,
      })}
    </>
  );
};

const getServerSideProps = makeServerProps({
  keyRoute: ERouting.CHARTS,
  hasSanity: true,
});

export { getServerSideProps };

export default PageCharts;
